import CheckBox from '@app/components/CheckBox'
import ContactProfileImage from '@app/components/ContactProfileImage'
import MentionEditor from '@app/components/MentionEditor'
import { IComment } from '@app/models/Comment'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { EditorState } from 'draft-js'
import * as React from 'react'
import { Button } from 'reactstrap'
import * as CommentEditorModule from '../modules/commentEditor'

export interface ICommentEditorUIProps {
  contextId: string
  defaultPublic?: boolean
  onResize?: () => void
}

export interface ICommentEditorProps {
  comment?: IComment
}

type CommentEditorProps = ICommentEditorUIProps &
  ICommentEditorProps &
  ICurrentUserState &
  typeof CommentEditorModule.actionCreators

export default class CommentEditor extends React.PureComponent<
  CommentEditorProps
> {
  private containerRef: React.RefObject<HTMLDivElement>
  private clientHeight: number

  constructor(props: CommentEditorProps) {
    super(props)

    this.containerRef = React.createRef()
    this.clientHeight = 0

    bindFunctions(this)
  }

  public componentDidMount() {
    this.props.init(this.props.contextId, this.props.defaultPublic)
    if (this.containerRef.current) {
      this.clientHeight = this.containerRef.current.clientHeight
    }
  }

  public componentDidUpdate() {
    if (this.containerRef.current) {
      if (this.containerRef.current.clientHeight !== this.clientHeight) {
        this.clientHeight = this.containerRef.current.clientHeight
        if (this.props.onResize) {
          this.props.onResize()
        }
      }
    }
  }

  public render() {
    if (!this.props.user || !this.props.comment) {
      return null
    }

    return (
      <div ref={this.containerRef}>
        <div className='d-flex mt-3'>
          <div className='mr-2'>
            <ContactProfileImage contact={this.props.user.id} size={25} />
          </div>
          <div className='flex-grow-1'>
            <MentionEditor
              compact
              id={`new-comment-${this.props.contextId}`}
              editorState={this.props.comment.markupState}
              onChange={this._onChangeMarkup}
              placeholder='Write a comment...'
            />
          </div>
        </div>
        <div className='d-flex justify-content-between align-items-center my-2'>
          <div>
            <CheckBox
              onChange={this._onChangeIsPublic}
              value={this.props.comment ? this.props.comment.isPublic : false}
            >
              Make public
            </CheckBox>
          </div>
          <div>
            <Button color='primary' onClick={this._saveComment} size='sm'>
              Post
            </Button>
          </div>
        </div>
      </div>
    )
  }

  private _onChangeIsPublic(isPublic: boolean) {
    this.props.setIsPublic(this.props.contextId, isPublic)
  }

  private _onChangeMarkup(newEditorState: EditorState) {
    this.props.setMarkup(this.props.contextId, newEditorState)
  }

  private _saveComment() {
    if (this.props.comment) {
      this.props.saveComment(this.props.contextId, this.props.comment)
    }
  }
}
